import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import axios from "@/enhancers/axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import cookieManager from "../../../../utils/cookieManager";
import i18n from "../../../../i18n";
import DatePickerCustom from "../../../utilities/Form/datepicker";
import Select2 from "../../../utilities/Form/Select2";
import InputNumber from "../../../utilities/Form/InputNumber";
import moment from "moment";
import Input from "../../../utilities/Form/input";
import DropzoneCustom from "../../../utilities/Form/DropzoneCustom";
import { FormLabel } from "react-bootstrap";

const MySwal = withReactContent(Swal);

const BudgetForm = forwardRef((props, ref) => {
  const [form, setForm] = useState({
    Budget: {},
    configName: "",
  });
  const {
    helperBudget,
    isError,
    errorMessage
  } = props;
  const [branchList, setBranchList] = useState([]);
  const [coa3List, setCoa3List] = useState([]);
  const [configName, setConfigName] = useState("");
  const [maxUploadFiles] = useState(3);
  const [branchCurrent, setBranchCurrent] = useState(null);
  const [coa3Current, setCoa3Current] = useState(null);
  const [images, setImages] = useState([]);
  const [name, setName] = useState("");
  const [date, setDate] = useState(new Date());
  const [nominal, setNominal] = useState(0);
  const [showDetail, setShowDetail] = useState(false);
  useEffect(() => {
    if (helperBudget) {
      setBranchList(helperBudget.branch || []);
      setCoa3List(helperBudget.coa || []);
    }
  }, [helperBudget]);

  const updateDropzone = (files) => {
    setImages(files);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "configName") setConfigName(value);
  };

  useImperativeHandle(ref, () => ({
    runSubmit() {
      const Budget = {
        idBranch: branchCurrent ? branchCurrent.value : null,
        coa3: coa3Current ? coa3Current.value : null,
        balance: nominal,
        name: configName,
        images: images.length > 0 ? images : null,
        date: moment(date).format("YYYY-MM-DD"),
      };
      return { Budget };
    },
  }));

  const renderError = (name) => {
    if (isError && errorMessage?.[name]) {
      return i18n.t(errorMessage[name][0]);
    }
    return "";
  };

  const changeData = async ({
    keyFill,
    type = null,
    key = "",
    array = null,
    arraykey = null,
    callback = () => {},
  }) => {
    const token = cookieManager.getUserToken();
    if (!type) return;

    let url = "";
    let params = null;

    switch (type) {
      case "getBank":
        url = `${process.env.REST_URL}helper/get-bank`;
        params = { branch: branchCurrent?.value || null };
        break;
      default:
        return;
    }

    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params,
      });

      if (response.status === 200 && response.data) {
        const dataResponse =
          key === ""
            ? response.data.result
            : response.data.result[key] || [];

        if (array) {
          const arr = [...array];
          const obj = arr[arraykey];
          obj[keyFill] = dataResponse;
          callback(dataResponse);
        } else {
          callback(dataResponse);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form>
      <div className="row">
        {/* Date */}
        <div className="col-md-4 mt-3">
          <DatePickerCustom
            name="date"
            title={i18n.t("Date")}
            required
            selected={date}
            onSelect={(e) => setDate(e)}
            dateFormat="dd MMMM yyyy"
            className="form-control form-control-md"
          />
        </div>

        {/* Branch */}
        <div className="col-md-4 mt-3">
          <Select2
            isClearable
            name="idBranch"
            required
            title={i18n.t("Branch")}
            options={branchList}
            value={branchCurrent}
            placeholder={i18n.t("Select Branch")}
            onChange={(e) => setBranchCurrent(e)}
          />
          <div className="fv-plugins-message-container invalid-feedback">
            {renderError("Budget.idBranch")}
          </div>
        </div>
         <div className="col-md-4 mt-3">
            <Input
                type={"input"}
                name={"configName"}
                title={i18n.t("Budget Name")}
                required
                value={configName || ""}
                handler= {(e) => handleChange(e)}
                className="form-control form-control-md"

            />
        </div>
      </div>

      <div className="row">
        {/* COA 3 */}
        <div className="col-md-4 mt-3">
          <Select2
            isClearable
            name="coa3"
            required
            title={i18n.t("COA 3")}
            options={coa3List}
            value={coa3Current}
            placeholder={i18n.t("Select COA 3")}
            onChange={(e) => setCoa3Current(e)}
          />
          <div className="fv-plugins-message-container invalid-feedback">
            {renderError("Budget.coa3")}
          </div>
        </div>

        {/* Nominal */}
        <div className="col-md-4 mt-3">
          <InputNumber
            id="nominal"
            name="nominal"
            placeholder={i18n.t("Nominal")}
            title={i18n.t("Limit")}
            value={nominal}
            decimalsLimit={2}
            prefix="Rp "
            onValueChange={(value) => setNominal(value)}
            disabled={showDetail}
            className="form-control form-control-md text-end"
          />
          <div className="fv-plugins-message-container invalid-feedback">
            {renderError("nominal")}
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-6">
            <FormLabel>
              {i18n.t("Upload Files")} ({i18n.t("max")} {maxUploadFiles}{" "}
              {i18n.t("items")})
            </FormLabel>
            <DropzoneCustom
              maxFiles={maxUploadFiles}
              acceptFiles={{
                "image/jpeg": [],
                "image/png": [],
                "application/pdf": [],
                "application/vnd.ms-excel": [],
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                  [],
                "text/csv": [],
              }}
              maxSize={2 * 1024 * 1024}
              changeFiles={updateDropzone}
            />
          </div>
      </div>
      </div>

    </form>
  );
});

export default BudgetForm;
